export enum RoleEnum {
    TEACHER = "1",
    STUDENT = "2",
    ANONYMUS = "3",
    ADMIN = "4"
}
